import React, { useEffect, useState } from "react"
import showpasswordlogo from "../../../../assets/images/lystfacelogos/showpassword.svg"
import hidpasswordlogo from "../../../../assets/images/lystfacelogos/hidepassword.svg"
import { createSelector } from "reselect"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
} from "reactstrap"
import Select from "react-select"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

//Import Breadcrumb

import form_messages from "../../../../constants/form_messages"
import withRouter from "../../../Common/withRouter"
import { ForgotPasswordUpdate, resetForgotPswdResponseMsg } from "../../../../store/actions"
import form_input_patterns from "../../../../constants/form_input_patterns"
import SmallLoader from "../../../Common/SmallLoader"
import PasswordToolTip from "../../../Common/PasswordToolTip"
import { CustomToast } from "../../Common/CustomToast"

const NewPasswordForm = props => {
  const dispatch = useDispatch()

  const ForgotPasswordState = state => state.ForgetPassword
  const ForgotPasswordProperties = createSelector(
    ForgotPasswordState,
    ForgotPassword => ({
      loading: ForgotPassword.loading,
      forgotPasswordErrorMessage: ForgotPassword.forgotPasswordErrorMessage,
      forgotPasswordError: ForgotPassword.forgotPasswordError,
      user: ForgotPassword.user,
    })
  )
  const { forgotPasswordError, forgotPasswordErrorMessage, loading } =
    useSelector(ForgotPasswordProperties)


  const [isShowPassword, setIsShowPassword] = useState({
    password: false,
    confirmPassword: false,
  })


  useEffect(() => {
    if (forgotPasswordErrorMessage !== null && forgotPasswordError) {
      CustomToast({
        message: forgotPasswordErrorMessage,
        status: forgotPasswordError ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
      dispatch(resetForgotPswdResponseMsg())
    }

  }, [forgotPasswordError, forgotPasswordErrorMessage])

  const validationType = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object().shape({
      password: Yup.string()
        .matches(
          form_input_patterns.PASSWORD,
          form_messages.Signup.password.MATCH
        )
        .required(form_messages.Signup.password.Required),

      confirmPassword: Yup.string().when("password", (password, schema) => {
        return password && password.length > 0
          ? schema
            .oneOf([Yup.ref("password")], form_messages.Signup.password.SAME)
            .required(form_messages.Signup.password.ConfirmRequired)
          : schema.notRequired()

      }),
    }),
    onSubmit: async values => {
      const UpdatePwd = {
        Password: values.password,
        passId: props.passId,
      }
      dispatch(ForgotPasswordUpdate(UpdatePwd, props.router.navigate))
    },
  })

  const handleSetPassword = (e) => {
    setIsShowPassword(prev => {
      return {
        ...prev,
        [e.target.name]: !isShowPassword?.[e.target.name],
      }
    })
  }

  const onSubmitForm = (e) => {
    e.preventDefault()
    validationType.handleSubmit()
    return false
  }

  return (
    <React.Fragment>
      <div className="auth-form-container">
        <Card>
          <CardBody>
            <Form
              onSubmit={e => onSubmitForm(e)}
              className="custom-validation"
            >
              <div className="title">
                Set new password
              </div>
              <div>

              </div>
              <div className="form-fields-container">
                <div className={`form-password-container ${validationType.touched.password && validationType.errors.password
                  ? ``
                  : `conditional-margin`
                  }`}>
                  <div className="d-flex align-items-end">
                    <Label className="me-1 form-input-title">
                      New password
                      <span className="text-danger"> *</span>
                    </Label>
                    <PasswordToolTip />
                  </div>


                  <Input
                    name="password"
                    className={` form-input password-input ${validationType.touched.password &&
                      validationType.errors.password
                      ? `border-danger`
                      : ``
                      }`}
                    type={isShowPassword.password ? `text` : "password"}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(/\s/g, ''); // Remove spaces
                      validationType.setFieldValue('password', inputValue); // Directly set the field value
                    }}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.password || ""}
                  />
                  <span onClick={(e) => handleSetPassword(e)} className="password-icon">
                    <img
                      name="password"
                      src={
                        isShowPassword.password
                          ? showpasswordlogo
                          : hidpasswordlogo
                      }
                    />
                  </span>

                </div>
                <div className="conditional-margin">

                  {validationType.touched.password &&
                    validationType.errors.password ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.password}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className={`form-password-container ${validationType.touched.confirmPassword && validationType.errors.confirmPassword
                  ? ``
                  : `conditional-margin`
                  }`}>
                  <Label className="form-input-title">
                    Confirm password<span className="text-danger"> *</span>
                  </Label>

                  <Input
                    name="confirmPassword"
                    type={isShowPassword.confirmPassword ? `text` : "password"}
                    className={`form-input password-input ${validationType.touched.confirmPassword && validationType.errors.confirmPassword
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(/\s/g, ''); // Remove spaces
                      validationType.setFieldValue('confirmPassword', inputValue); // Directly set the field value
                    }}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.confirmPassword || ""}
                  />
                  <span onClick={(e) => handleSetPassword(e)} className="password-icon">
                    <img
                      name="confirmPassword"
                      src={
                        isShowPassword.confirmPassword
                          ? showpasswordlogo
                          : hidpasswordlogo
                      }
                    />
                  </span>

                </div>
                <div className="conditional-margin">

                  {validationType.touched.confirmPassword &&
                    validationType.errors.confirmPassword ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.confirmPassword}
                    </FormFeedback>
                  ) : null}
                </div>

              </div>
              <div className="text-center mt-3">
                <button className="background-button text-light" disabled={loading}
                >
                  {loading ?
                    <SmallLoader /> : "Confirm"
                  }
                </button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  )
}

export default withRouter(NewPasswordForm)

NewPasswordForm.propTypes = {
  history: PropTypes.object,
  passId: PropTypes.string,
}
